document.addEventListener('DOMContentLoaded', async () => {
  const cartDataElement = document.getElementById('jm-cart-inventory-data');
  const selector = document.getElementById('jm-fulfillment-selector');

  if (!cartDataElement || !selector) return;

  let cartItems;

  try {
    cartItems = JSON.parse(cartDataElement.textContent);
  } catch (error) {
    console.error('JM cart data error:', error);
    return;
  }

  if (!cartItems.length) return;

  const token = window.JM_LOCATION_INVENTORY_TOKEN;
  const API_URL = '/api/2026-10/graphql.json';

  if (!token) {
    console.error('JM Storefront token is missing.');
    return;
  }

  const query = `
    query JMCartLocationInventory($id: ID!) {
      node(id: $id) {
        ... on ProductVariant {
          storeAvailability(first: 20) {
            nodes {
              quantityAvailable
              location {
                name
              }
            }
          }
        }
      }
    }
  `;

  const inventoryResults = [];

  for (const item of cartItems) {
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({
          query,
          variables: {
            id: `gid://shopify/ProductVariant/${item.variantId}`
          }
        })
      });

      const result = await response.json();

      if (result.errors) {
        console.error('JM cart inventory error:', result.errors);
        continue;
      }

      inventoryResults.push({
        ...item,
        locations: result?.data?.node?.storeAvailability?.nodes || []
      });
    } catch (error) {
      console.error('JM cart inventory error:', error);
    }
  }

  window.JM_CART_LOCATION_INVENTORY = inventoryResults;

  console.log('JM cart location inventory:', inventoryResults);
  const optionsContainer = document.getElementById('jm-fulfillment-options');
const checkoutButton = document.getElementById('checkout');

if (!optionsContainer || !checkoutButton) return;

// For now, show the selector when a cart item needs inventory
// from more than one B. Monroe salon.
const cartInventory = inventoryResults.map((item) => {
  const macon = item.locations.find(
    (location) => location.location.name === 'B. Monroe Salon - Macon'
  );

  const wr = item.locations.find(
    (location) => location.location.name === 'B. Monroe Salon - WR'
  );

  const maconQty = Math.max(0, macon?.quantityAvailable || 0);
  const wrQty = Math.max(0, wr?.quantityAvailable || 0);
  const totalSalonQty = maconQty + wrQty;

  return {
    ...item,
    maconQty,
    wrQty,
    totalSalonQty,
    needsSpecialOrder: item.quantity > totalSalonQty
  };
});

const needsSpecialOrder = cartInventory.some(
  (item) => item.needsSpecialOrder
);


selector.style.display = 'block';

const selectorHeading = selector.querySelector('h3');

if (selectorHeading) {
  selectorHeading.textContent = 'How would you like to receive your hair?';
}
const pickupAvailabilityHTML = cartInventory
  .map((item) => {
    const itemName =
      item.variantTitle && item.variantTitle !== 'Default Title'
        ? `${item.title} – ${item.variantTitle}`
        : item.title;

    return `
      <div style="margin-bottom: 14px;">
        <p style="margin: 0 0 4px 0;">
          <strong>${itemName}</strong> — ${item.quantity} requested
        </p>
        <p style="margin: 0 0 2px 0;">
          Macon: ${item.maconQty} Ready Now
        </p>
        <p style="margin: 0;">
          Warner Robins: ${item.wrQty} Ready Now
        </p>
      </div>
    `;
  })
  .join('');

optionsContainer.innerHTML = `
<label class="jm-fulfillment-option" style="display: flex; align-items: flex-start; gap: 10px; margin: 0 0 16px 0; padding: 16px; border: 1px solid rgba(0,0,0,.15); border-radius: 8px; cursor: pointer;">
    <input type="radio" name="jm_delivery_method" value="ship">
    <span>
      <strong>Ship my order</strong><br>
      Delivered to your address<br>
      <small>Shipping options shown at checkout</small>
    </span>
  </label>

<label class="jm-fulfillment-option" style="display: flex; align-items: flex-start; gap: 10px; margin: 0 0 16px 0; padding: 16px; border: 1px solid rgba(0,0,0,.15); border-radius: 8px; cursor: pointer;">
    <input type="radio" name="jm_delivery_method" value="pickup">
    <span>
      <strong>Pick up locally</strong><br>
      B. Monroe Salon in Macon or Warner Robins
    </span>
  </label>

<div id="jm-local-pickup-options" style="display: none; margin-top: 16px; padding: 16px; border: 1px solid rgba(0,0,0,.15); border-radius: 8px;">
  <p style="margin: 0 0 14px 0;">
    <strong>Pickup availability</strong>
  </p>

  ${pickupAvailabilityHTML}

  ${
    needsSpecialOrder
      ? `
        <p style="margin: 0;">
          Your order includes more hair than is currently Ready Now at our salon locations.
          Additional hair will need to be ordered before your complete order is ready for pickup.
          <strong>Please allow approximately 4–5 weeks.</strong>
        </p>
      `
      : `
        <p style="margin: 0;">
          Choose Macon or Warner Robins at checkout. If your complete order isn't already at your selected salon, we'll transfer it for you.
          <strong>We'll email you as soon as your complete order is ready, within 24 hours.</strong>
        </p>
      `
  }
</div>
`;

const localPickupOptions = document.getElementById('jm-local-pickup-options');

checkoutButton.disabled = true;
async function saveJMCartAttributes(attributes) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('Unable to save JM fulfillment choice.');
    }

    return await response.json();
  } catch (error) {
    console.error('JM fulfillment save error:', error);
    return null;
  }
}

optionsContainer
  .querySelectorAll('input[name="jm_delivery_method"]')
  .forEach((radio) => {
    radio.addEventListener('change', async () => {
      if (radio.value === 'ship' && radio.checked) {
        localPickupOptions.style.display = 'none';

        optionsContainer
          .querySelectorAll('input[name="jm_fulfillment"]')
          .forEach((pickupRadio) => {
            pickupRadio.checked = false;
          });

        checkoutButton.disabled = true;

        await saveJMCartAttributes({
          'JM Delivery Method': 'Ship',
          'JM Pickup Plan': ''
        });

        checkoutButton.disabled = false;
      }

if (radio.value === 'pickup' && radio.checked) {
  localPickupOptions.style.display = 'block';
  checkoutButton.disabled = true;

  await saveJMCartAttributes({
    'JM Delivery Method': 'Local Pickup',
    'JM Pickup Plan': 'Choose pickup location at checkout'
  });

  checkoutButton.disabled = false;
}
    });
  });
  let jmQuantityChangeTimer;

document.addEventListener('change', (event) => {
  const quantityInput = event.target.closest('input[name="updates[]"]');

  if (!quantityInput) return;

  clearTimeout(jmQuantityChangeTimer);

  jmQuantityChangeTimer = setTimeout(() => {
    window.location.reload();
  }, 1200);
});
});